function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { findByType } from "../../../data";
import { useRoadRunnerDashboardAggregatedData, useRoadRunnerDashboardPageMutation } from "./aggregatedData";
import { FormDefinition } from "../../../components/DynamicForm";
import { z } from 'zod';
var EvaluationTaskAttributesSchema = z.object({
  // TODO: remove this after BE API is deployed
  applicationId: z.union([z.string(), z.number()]),
  // TODO: remove .nullish() after BE API is deployed
  applicationNumber: z.number().nullish(),
  taskTitle: z.string(),
  fileContent: z.array(z.object({
    files: z.array(z.object({
      contentType: z.string(),
      fileDownloadLink: z.string(),
      fileName: z.string(),
      alerts: z.array(z.object({
        severity: z.literal('warning'),
        message: z.string()
      })).optional()
    })),
    groupTitle: z.string()
  })).optional(),
  status: z.string(),
  formDefinition: FormDefinition,
  rejectionOptions: z.array(z.object({
    code: z.string(),
    description: z.string()
  })),
  assigneeLegacyId: z.number().nullish(),
  notices: z.array(z.object({
    intent: z["enum"](['warning']),
    message: z.string()
  }))
});
export function useEvaluationTask() {
  var _useRoadRunnerDashboa = useRoadRunnerDashboardAggregatedData({
      select: function select(data) {
        var task = findByType(data.included, 'evaluation_task');
        if (!task) {
          return;
        }
        return _objectSpread(_objectSpread({}, EvaluationTaskAttributesSchema.parse(task.attributes)), {}, {
          id: task.id
        });
      }
    }),
    data = _useRoadRunnerDashboa.data,
    isLoading = _useRoadRunnerDashboa.isLoading;
  return {
    evaluationTask: data,
    isLoadingEvaluationTask: isLoading
  };
}
export function useCreateEvaluationTask() {
  var _useRoadRunnerDashboa2 = useRoadRunnerDashboardPageMutation(function () {
      return {
        url: "/evaluation-tasks",
        method: 'POST'
      };
    }),
    mutate = _useRoadRunnerDashboa2.mutate,
    isLoading = _useRoadRunnerDashboa2.isLoading;
  return {
    createEvaluationTask: mutate,
    isCreatingEvaluationTask: isLoading
  };
}
export function useSnoozeTask() {
  var _useRoadRunnerDashboa3 = useRoadRunnerDashboardPageMutation(function (_ref) {
      var id = _ref.id;
      return {
        url: "/awa/v1/support_members/me/evaluation_tasks/".concat(id),
        method: 'PATCH',
        body: {
          data: {
            id: id,
            type: 'evaluation_task',
            attributes: {
              status: 'snoozed'
            }
          }
        }
      };
    }),
    mutate = _useRoadRunnerDashboa3.mutate,
    isLoading = _useRoadRunnerDashboa3.isLoading;
  return {
    snoozeEvaluationTask: mutate,
    isSnoozingTask: isLoading
  };
}
export function useDeleteTask() {
  var _useRoadRunnerDashboa4 = useRoadRunnerDashboardPageMutation(function (_ref2) {
      var id = _ref2.id;
      return {
        url: "/awa/v1/support_members/me/evaluation_tasks/".concat(id),
        method: 'PATCH',
        body: {
          data: {
            id: id,
            type: 'evaluation_task',
            attributes: {
              status: 'canceled'
            }
          }
        }
      };
    }),
    mutate = _useRoadRunnerDashboa4.mutate,
    isLoading = _useRoadRunnerDashboa4.isLoading;
  return {
    deleteEvaluationTask: mutate,
    isDeletingTask: isLoading
  };
}
export function useCompleteTask() {
  var _useRoadRunnerDashboa5 = useRoadRunnerDashboardPageMutation(function (_ref3) {
      var id = _ref3.id,
        values = _ref3.values;
      return {
        url: "/awa/v1/support_members/me/evaluation_tasks/".concat(id),
        method: 'PATCH',
        body: {
          data: {
            id: id,
            type: 'evaluation_task',
            attributes: {
              status: 'done',
              results: {
                decision: 'accepted',
                formData: values
              }
            }
          }
        }
      };
    }),
    mutate = _useRoadRunnerDashboa5.mutate,
    isLoading = _useRoadRunnerDashboa5.isLoading;
  return {
    completeEvaluationTask: mutate,
    isCompletingTask: isLoading
  };
}
export function useRejectTask() {
  var _useRoadRunnerDashboa6 = useRoadRunnerDashboardPageMutation(function (_ref4) {
      var id = _ref4.id,
        rejectionOptionCode = _ref4.rejectionOptionCode,
        notes = _ref4.notes;
      return {
        url: "/awa/v1/support_members/me/evaluation_tasks/".concat(id),
        method: 'PATCH',
        body: {
          data: {
            id: id,
            type: 'evaluation_task',
            attributes: {
              status: 'done',
              results: {
                decision: 'rejected',
                rejectionOptionCode: rejectionOptionCode,
                notes: notes
              }
            }
          }
        }
      };
    }),
    mutate = _useRoadRunnerDashboa6.mutate,
    isLoading = _useRoadRunnerDashboa6.isLoading;
  return {
    rejectEvaluationTask: mutate,
    isRejectingTask: isLoading
  };
}
export function useStartEvaluationTask() {
  var _useRoadRunnerDashboa7 = useRoadRunnerDashboardPageMutation(function (_ref5) {
      var id = _ref5.id;
      return {
        url: "/awa/v1/support_members/me/evaluation_tasks",
        method: 'POST',
        body: {
          data: {
            id: id,
            type: 'evaluation_task'
          }
        }
      };
    }),
    mutate = _useRoadRunnerDashboa7.mutate,
    isLoading = _useRoadRunnerDashboa7.isLoading;
  return {
    startEvaluationTask: mutate,
    isStartingEvaluationTask: isLoading
  };
}
export function useTaskId() {
  var _useRoadRunnerDashboa8 = useRoadRunnerDashboardAggregatedData({
      select: function select(data) {
        var task = findByType(data.included, 'evaluation_task');
        if (!task) {
          return;
        }
        return {
          id: task.id
        };
      },
      useErrorBoundary: false
    }),
    data = _useRoadRunnerDashboa8.data;
  return {
    taskId: data === null || data === void 0 ? void 0 : data.id
  };
}